module.exports = __webpack_public_path__ + "AdobeStock_285202108_monitor2_iconcolors2.svg?8a4dfbc6acfa6e3c16fe624c30e50d80";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/landing/AdobeStock_285202108_monitor2_iconcolors2.svg
// module id = 327
// module chunks = 0